import { useTranslations } from '@vocab/react';
import { Alert, Box, Text } from 'braid-design-system';
import React from 'react';

import type { FriendlyError } from '../../../modules/Auth0/types';
import getHashRoute from '../../../utils/getHashRoute';
import { LOGIN } from '../../pages/LoginPage/hashRoutes';
import TrackLink from '../TrackLink/TrackLink';

import translations from './.vocab';

interface Props {
  error: FriendlyError | undefined;
  ignoreErrors?: FriendlyError[];
  emailAddress?: string;
}

const ServerError = ({ error, emailAddress, ignoreErrors = [] }: Props) => {
  const { t } = useTranslations(translations);

  if (!error || ignoreErrors.indexOf(error) !== -1) {
    return null;
  }

  return (
    <Alert tone="critical">
      <Text>
        {t(error, {
          email: emailAddress,
          SignInLink: (v: any) => (
            <TrackLink
              key="link"
              href={getHashRoute(LOGIN)}
              weight="weak"
              trackingData={{
                eventName: 'login_pressed',
                linkPosition: 'body',
                isThirdPartyLink: 'false',
              }}
            >
              {v}
            </TrackLink>
          ),
          Linebreak: (v: any) => <Box paddingBottom="medium">{v}</Box>,
        })}
      </Text>
    </Alert>
  );
};

export default ServerError;
